import TabNavigation from './components/TabNavigation/TabNavigation';

const PropertyBuilder = ({ showToast, setIsLoading, onPropertyLoadingChange }) => {
  return (
    <div className="hvnly--builder--int_api__property_builder_wrapper">
      <TabNavigation
        showToast={showToast}
        setIsLoading={setIsLoading}
        onPropertyLoadingChange={onPropertyLoadingChange}
      />
    </div>
  );
};

export default PropertyBuilder;